import classNames from 'classnames';
import isArray from 'lodash/isArray';
import React from 'react';
import { MenuItem } from 'react-bootstrap-typeahead';
import Highlighter from 'react-highlight-words';

import { HighlightKeyword } from 'root/widgets/common-components/highlight-keyword';

import { extractDataAutomationId } from 'root/widgets/utils';

import { TypeaheadOptionType } from './constants';
import './found-locations-view.scss';
import { FoundLocationItemProps, FoundLocationsViewProps } from './types';
import { getIconClass } from './utils';

const FoundLocationItem: React.FC<FoundLocationItemProps> = (props) => {
  const { className, position, searchKeyword, location, metadata, onLocationSelect } = props;
  const displayDescription = isArray(location.displayDescription)
    ? location.displayDescription
    : [location.displayDescription];

  const handleClick = () => {
    if (onLocationSelect) {
      onLocationSelect(location);
    }
  };
  const searchWords = searchKeyword.split(' ');

  return (
    <MenuItem
      className={classNames('found-locations-view-item-root', className)}
      option={{ ...location, optionType: TypeaheadOptionType.FoundLocation }}
      position={position}
      onClick={handleClick}
      {...extractDataAutomationId(metadata)}
    >
      <i className={getIconClass(location.objectType)} />
      <div className="found-location-content">
        <div className="found-location-header">
          <span className="found-location-view-title">
            <Highlighter
              highlightClassName="highlight-search"
              highlightTag={HighlightKeyword}
              searchWords={searchWords}
              autoEscape
              textToHighlight={location.displayText}
            />
          </span>
          <span className="found-location-view-label">{location.displayType}</span>
        </div>
        <div className="found-location-view-meta">
          {displayDescription.map((description, index) => (
            <span key={description} className="found-location-description">
              <span className={classNames('pgicon', 'pgicon-circle', { hide: !index })} />
              <Highlighter
                highlightClassName="highlight-search"
                highlightTag={HighlightKeyword}
                searchWords={searchWords}
                autoEscape
                textToHighlight={description}
              />
            </span>
          ))}
        </div>
      </div>
    </MenuItem>
  );
};

const FoundLocationsView: React.FC<FoundLocationsViewProps> = (props) => {
  const { className, searchKeyword, foundLocations, positions, metadata, onLocationSelect } = props;

  return (
    <div {...extractDataAutomationId(metadata)}>
      {foundLocations.length > 0 &&
        foundLocations.map((location, idx) => (
          <FoundLocationItem
            className={className}
            position={positions[idx]}
            option={location}
            key={location.objectId}
            searchKeyword={searchKeyword}
            location={location}
            onLocationSelect={onLocationSelect}
            metadata={{
              dataAutomationId: metadata?.dataAutomationId ? `${metadata?.dataAutomationId}-${idx}` : '',
            }}
          />
        ))}
    </div>
  );
};

FoundLocationsView.displayName = 'FoundLocationsView';

export default FoundLocationsView;
